import React from 'react';
import IconFilm from '../../../assets/icons/icon-film-small.svg';
import IconFilmDark from '../../../assets/icons/icon-film-small-dark.svg';
import styles from './Cinema.module.scss';
import Cookies from 'js-cookie';
import { buildUrl } from 'utils/helpers';

const Cinema = (props) => {
  const { 
    cinemaData,
    setFilter,
    isPopup,
    homeURL,
    useSiteAsFilter,
    setActiveTab,
    colorScheme,
    concessionBtnText,
    concessionSiteLink,
    concessionLinkNewTab,
    concessionEnabledParam,
    testCinemasEnabled
  } = props

  const handleCinemaClick = (e) => {
    e.preventDefault();
    
    const siteId = e.currentTarget.attributes['data-site-id'].value;
    const siteName = e.currentTarget.attributes['data-site-name'].value;
    let siteLink = e.currentTarget.attributes['href'].value;
    const isFilter = !!document.querySelector('.popup__choose-cinema.active.active-filter');
    
    if (cinemaData.externalLink) {
      document.body.classList.add('is-loading');

      // redirect the user to the cinama site if external link is set
      window.location = cinemaData.externalLink;
      
      return;
    } else if (isFilter) { // do not redirect (single movie page)
      // update the selected cinema (reservation step)
      document.querySelector('.choose-cinema-options .choose-cinema span').innerText = siteName;

      // update (hidden field) filter value
      document.querySelector('[name="field-reservation-site"]').value = siteId;
      document.querySelector('[name="field-reservation-site"]').dispatchEvent(new Event("change"));

      // close the popup
      document.querySelector('.choose-cinema').click();
    } else {
      // remove selected favourite cinema
      if (siteId === '0') {
        // remove the cookie
        Cookies.remove('selectedMyCinema');

        // set the defaul link text
        const cinemaPopupLink = document.querySelector('.show-cinemas-popup');
        document.querySelector('.show-cinemas-popup span').textContent = cinemaPopupLink.getAttribute('data-default-text');
        
        // redirect the user to the homepage 
        window.location = homeURL;

        return;
      }
      
      if (isPopup) {
        const cookieVal = siteId + '|' + siteName;
        const urlGlue = siteLink.indexOf('?') === -1 ? '?' : '&';

        Cookies.set('selectedMyCinema', cookieVal);

        document.querySelector('.show-cinemas-popup span').textContent = siteName;

        // fix - some browsers (Chromium based - Google Chrome, etc.)
        // doesn't serve the cookies to the server (PHP)
        siteLink += (urlGlue + 'cinema_selected=1');
      }
      
      setFilter('cinema', [siteId], 'replace');

      if (useSiteAsFilter === '1') { // experience page
        setActiveTab(window.mapiTranslations['Choose Film']);
      } else {
        window.location = siteLink;
      }
    }
  }

  try {
    const iconFilmSrc = (colorScheme === 'light' || colorScheme === 'cinepolis') ? IconFilmDark : IconFilm;
    const isDropDownLayout = !!document.querySelector('.popup__choose-cinema.as-drop-down');
    let cinemaUrl = homeURL + 'cinema/' + cinemaData.slug + '/';
    let concessionLinkURL = (concessionSiteLink || '').replace('{site}', cinemaData.id);

    if (concessionLinkURL && concessionEnabledParam === '1') {
      concessionLinkURL += '&concessionEnabled=1';
    }

    if (concessionEnabledParam) {
      if (cinemaUrl.indexOf('?') === -1) {
        cinemaUrl += '?concessionEnabled=' + concessionEnabledParam;
      } else {
        cinemaUrl += '&concessionEnabled=' + concessionEnabledParam;
      }
    }

    if (testCinemasEnabled) {
      if (cinemaUrl.indexOf('?') === -1) {
        cinemaUrl += '?isTest=' + testCinemasEnabled;
      } else {
        cinemaUrl += '&isTest=' + testCinemasEnabled;
      }
    }

    return (
      <React.Fragment>
        { ((isPopup ) || (!isPopup && cinemaData.id !== 0)) &&
          <div className={styles.cinema + ' ' + (isDropDownLayout ? styles.dropDownLayout : '')}>
            <a 
              href={cinemaUrl} 
              data-site-id={cinemaData.id} 
              data-site-name={cinemaData.name} 
              data-site-address={cinemaData.address} 
              onClick={handleCinemaClick}
            >
              <h4>{cinemaData.name}</h4>

              <p>{cinemaData.address}</p>

              <div className={styles.attributes}>
                <img src={buildUrl([homeURL, iconFilmSrc])} alt="" /> 

                {
                  cinemaData.availAttrs.map(attr => <span>{attr}</span>)
                }
              </div>
            </a>

            {
              (concessionLinkURL && (cinemaData.isConcessionEnabled || (cinemaData.isManagerAllowed && concessionEnabledParam === '1'))) &&
              <a
                href={concessionLinkURL} 
                target={concessionLinkNewTab === '1' ? '_blank' : '_self'}
                rel={concessionLinkNewTab === '1' ? 'noopener noreferrer' : undefined}
                className={styles.concessionLink}
              >
                {concessionBtnText}
              </a>
            }
          </div>
        }
      </React.Fragment>
    );
  } catch (err) {
    console.error('Skipping cinema due to error', cinemaData, err);
    return null; // skip rendering this item
  }
}

export { Cinema };
